import { render, staticRenderFns } from "./riskRelationDocu.vue?vue&type=template&id=ca5aeac6"
import script from "./riskRelationDocu.vue?vue&type=script&lang=js"
export * from "./riskRelationDocu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca5aeac6')) {
      api.createRecord('ca5aeac6', component.options)
    } else {
      api.reload('ca5aeac6', component.options)
    }
    module.hot.accept("./riskRelationDocu.vue?vue&type=template&id=ca5aeac6", function () {
      api.rerender('ca5aeac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskRelationDocu.vue"
export default component.exports